// extracted by mini-css-extract-plugin
module.exports = {"required":"FormLeaveType_required_XNa0N","error":"FormLeaveType_error_1f-IY","radioBox":"FormLeaveType_radioBox_C-TNW","label":"FormLeaveType_label_1pGrN"};